import styled from 'styled-components'
import { Alert } from 'shards-react'

export const GenericAlert = styled(Alert)`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
`
